import { Component, Inject, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TUI_IS_IOS, TUI_IS_MOBILE } from '@taiga-ui/cdk';
import { TabsService } from './tabs.service';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/config.service';
import { GlobalDataService } from '../../services/global-data.service';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
})
export class TabsComponent {
  isVisible$ = this.tabsService.isVisible$;
  window = window;
  transfersUrl = "" //`${inject(ConfigService).config.transfersUrl}?tracker=${inject(AuthService).getUser().id}`;
  creditsUrl = "" //`${inject(ConfigService).config.creditsUrl}`;
  constructor(
    public router: Router,
    private globalDataService: GlobalDataService,
    @Inject(TUI_IS_MOBILE) readonly isMobile: boolean,
    @Inject(TUI_IS_IOS) readonly isIos: boolean,
    private tabsService: TabsService
  ) {
    this.transfersUrl = this.globalDataService.transfersUrlData ?? ''
    this.creditsUrl = this.globalDataService.creditsUrlData ?? ''
  }

  isEsimActive(): boolean {
    const url = this.router.url;
    return url.includes('esim') || url.includes('my-esims');
  }

  navigateToEsim(): void {
    if (this.globalDataService.userEsimsCount > 0) {
      this.router.navigate(['/my-esims']);
    } else {
      this.router.navigate(['/esim']);
    }
  }
}
